"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("../utils/omit"));

var _controlLabel = _interopRequireDefault(require("../control-label"));

var _controlWrapper = _interopRequireDefault(require("../control-wrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var propNames = ['id', 'value', 'onChange', 'label', 'noAuto', 'optional', 'aside', 'validationError', 'themeControlTextarea', 'themeControlWrapper', 'themeLabel', // Passed when used with the Form component
'initialValue', 'validator'];

var ControlTextarea =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ControlTextarea, _React$Component);

  function ControlTextarea() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ControlTextarea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ControlTextarea)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (e) {
      return _this.props.onChange(e.target.value, _this.props.id);
    });

    return _this;
  }

  _createClass(ControlTextarea, [{
    key: "render",
    value: function render() {
      var extraProps = (0, _omit.default)(this.props, propNames);
      var _this$props = this.props,
          id = _this$props.id,
          value = _this$props.value,
          label = _this$props.label,
          optional = _this$props.optional,
          aside = _this$props.aside,
          validationError = _this$props.validationError,
          noAuto = _this$props.noAuto,
          themeControlTextarea = _this$props.themeControlTextarea,
          themeControlWrapper = _this$props.themeControlWrapper,
          themeLabel = _this$props.themeLabel;
      var textareaProps = {
        id: id,
        name: id,
        onChange: this.onChange,
        value: value,
        className: themeControlTextarea,
        'aria-required': optional ? false : true,
        'data-test': "".concat(id, "-textarea")
      };

      if (noAuto) {
        textareaProps.autoCapitalize = 'none';
        textareaProps.autoCorrect = 'off';
        textareaProps.spellCheck = false;
      }

      if (validationError) {
        textareaProps['aria-invalid'] = true;
      }

      return _react.default.createElement(_controlWrapper.default, {
        themeControlWrapper: themeControlWrapper,
        id: id,
        validationError: validationError
      }, label && _react.default.createElement(_controlLabel.default, {
        text: label,
        id: id,
        aside: aside,
        optional: optional,
        themeLabel: themeLabel
      }), _react.default.createElement("textarea", _extends({}, textareaProps, extraProps)));
    }
  }]);

  return ControlTextarea;
}(_react.default.Component);

exports.default = ControlTextarea;

_defineProperty(ControlTextarea, "propTypes", {
  /** Unique id for this control. Required if you want a `label`. */
  id: _propTypes.default.string,

  /** The control's value. */
  value: _propTypes.default.string,

  /**
   * Invoked when the control's value changes.
   * Passed two arguments: the new value, and the `id` prop.
   */
  onChange: _propTypes.default.func.isRequired,

  /** Label for the control. */
  label: _propTypes.default.string,

  /** If `true`, autocorrect and spelling suggestions will be disabled. */
  noAuto: _propTypes.default.bool,

  /** If `true`, the text `(optional)` is appended to the label element. */
  optional: _propTypes.default.bool,

  /** Additional content inserted alongside the label element. */
  aside: _propTypes.default.node,

  /** A validation error to display beneath the control. */
  validationError: _propTypes.default.node,

  /** Classes to apply to the textarea element. */
  themeControlTextarea: _propTypes.default.string,

  /** Classes to apply to the control wrapper. */
  themeControlWrapper: _propTypes.default.string,

  /** Classes to apply to the label element. */
  themeLabel: _propTypes.default.string
});

_defineProperty(ControlTextarea, "defaultProps", {
  value: '',
  optional: false,
  noAuto: false,
  themeControlTextarea: 'textarea hmin120'
});